/* Glowrah storefront scripts: vanilla JavaScript using Shopify Ajax endpoints. */
(function () {
  'use strict';
  var d = document;
  var $ = function (selector, scope) { return (scope || d).querySelector(selector); };
  var $$ = function (selector, scope) { return Array.prototype.slice.call((scope || d).querySelectorAll(selector)); };
  var read = function (key, fallback) { try { return JSON.parse(localStorage.getItem(key)) || fallback; } catch (error) { return fallback; } };
  var write = function (key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (error) {} };
  var storeKeys = { wish: 'glowrah-wishlist', compare: 'glowrah-compare', viewed: 'glowrah-viewed', popup: 'glowrah-popup-dismissed' };
  var escapeHTML = function (value) { return String(value || '').replace(/[&<>"']/g, function (character) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[character]; }); };
  var money = function (cents) { return new Intl.NumberFormat(d.documentElement.lang || 'en', { style: 'currency', currency: window.Glowrah.currency || 'USD' }).format((Number(cents) || 0) / 100); };
  var lock = function (state) { d.body.classList.toggle('is-locked', state); };
  var notify = function (message) {
    var element = $('.js-toast');
    if (!element) return;
    element.textContent = message;
    element.classList.add('is-visible');
    clearTimeout(element._timer);
    element._timer = setTimeout(function () { element.classList.remove('is-visible'); }, 2800);
  };
  var toggleOverlay = function (element, state) {
    if (!element) return;
    element.classList.toggle('is-open', state);
    element.setAttribute('aria-hidden', String(!state));
    lock(state);
  };

  /* Navigation, cart and search overlays */
  var cartDrawer = $('.js-cart-drawer');
  var searchDrawer = $('.js-search-drawer');
  var mobileMenu = $('.js-mobile-menu');
  $$('.js-cart-open').forEach(function (button) { button.addEventListener('click', function () { toggleOverlay(cartDrawer, true); }); });
  $$('.js-drawer-close').forEach(function (button) { button.addEventListener('click', function () { toggleOverlay(cartDrawer, false); }); });
  $$('.js-search-open').forEach(function (button) { button.addEventListener('click', function () { toggleOverlay(searchDrawer, true); }); });
  $$('.js-search-close').forEach(function (button) { button.addEventListener('click', function () { toggleOverlay(searchDrawer, false); }); });
  $$('.js-menu-open').forEach(function (button) { button.addEventListener('click', function () { toggleOverlay(mobileMenu, true); }); });
  $$('.js-menu-close').forEach(function (button) { button.addEventListener('click', function () { toggleOverlay(mobileMenu, false); }); });
  d.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') [cartDrawer, searchDrawer, mobileMenu, $('.js-quick-view-modal'), $('.js-newsletter-popup')].forEach(function (item) { toggleOverlay(item, false); });
  });

  /* Ajax Cart: cart.js hydration avoids page reloads. */
  var cartItemHTML = function (item, line) {
    var image = item.image ? '<img class="cart-item__image" src="' + item.image + '" width="160" height="160" alt="' + escapeHTML(item.product_title) + '">' : '';
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<small>' + escapeHTML(item.variant_title) + '</small>' : '';
    return '<article class="cart-item"><a href="' + item.url + '">' + image + '</a><div class="cart-item__details"><a href="' + item.url + '">' + escapeHTML(item.product_title) + '</a>' + variant + '<strong>' + money(item.final_line_price) + '</strong><div class="quantity-selector"><button class="js-cart-quantity" type="button" data-line="' + line + '" data-quantity="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + item.quantity + '</span><button class="js-cart-quantity" type="button" data-line="' + line + '" data-quantity="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button><button class="cart-item__remove js-cart-quantity" type="button" data-line="' + line + '" data-quantity="0">Remove</button></div></div></article>';
  };
  var renderCart = function (cart) {
    $$('.js-cart-count').forEach(function (element) { element.textContent = cart.item_count; });
    var content = $('.js-cart-drawer-content');
    if (!content) return;
    if (!cart.item_count) {
      content.innerHTML = '<div class="empty-state"><p>Your cart is currently empty.</p><a class="button button--secondary" href="/collections/all">Continue shopping</a></div>';
      return;
    }
    var items = cart.items.map(function (item, index) { return cartItemHTML(item, index + 1); }).join('');
    content.innerHTML = '<div class="cart-items">' + items + '</div><footer class="drawer__footer"><div class="drawer__subtotal"><span>Subtotal</span><strong>' + money(cart.total_price) + '</strong></div><p>Shipping and taxes calculated at checkout.</p><a class="button button--full" href="' + window.Glowrah.routes.cart + '">Checkout</a></footer>';
  };
  var getCart = async function () {
    var response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Could not load cart');
    var cart = await response.json();
    renderCart(cart);
    return cart;
  };
  var addToCart = async function (id, quantity, openDrawer) {
    var response = await fetch(window.Glowrah.routes.cart_add + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity || 1) }] })
    });
    if (!response.ok) {
      var errorBody = await response.json().catch(function () { return {}; });
      throw new Error(errorBody.description || 'This item cannot be added right now.');
    }
    await getCart();
    notify('Added to your cart');
    if (openDrawer !== false) toggleOverlay(cartDrawer, true);
  };
  d.addEventListener('click', async function (event) {
    var addButton = event.target.closest('.js-add-to-cart');
    if (addButton) {
      try { addButton.disabled = true; await addToCart(addButton.dataset.variantId, 1, true); } catch (error) { notify(error.message); } finally { addButton.disabled = false; }
    }
    var quantityButton = event.target.closest('.js-cart-quantity');
    if (quantityButton && Number(quantityButton.dataset.quantity) >= 0) {
      try {
        var response = await fetch(window.Glowrah.routes.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(quantityButton.dataset.line), quantity: Number(quantityButton.dataset.quantity) }) });
        renderCart(await response.json());
      } catch (error) { notify('Could not update your cart.'); }
    }
  });

  /* Announcement countdown */
  var countdown = $('.js-countdown');
  if (countdown) {
    var endTime = new Date(countdown.closest('[data-countdown]').dataset.countdown).getTime();
    var updateCountdown = function () {
      var difference = endTime - Date.now();
      if (!Number.isFinite(endTime) || difference <= 0) { countdown.textContent = ''; return; }
      var days = Math.floor(difference / 86400000);
      var hours = Math.floor(difference / 3600000) % 24;
      var minutes = Math.floor(difference / 60000) % 60;
      var seconds = Math.floor(difference / 1000) % 60;
      countdown.textContent = days + 'd ' + hours + 'h ' + minutes + 'm ' + seconds + 's';
    };
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  /* Hero carousel */
  $$('.hero').forEach(function (hero) {
    var slides = $$('.hero__slide', hero);
    var dots = $$('.js-hero-dot', hero);
    if (slides.length < 2) return;
    var active = 0;
    var timer;
    var show = function (index) {
      active = (index + slides.length) % slides.length;
      slides.forEach(function (slide, position) { slide.classList.toggle('is-active', position === active); });
      dots.forEach(function (dot, position) { dot.classList.toggle('is-active', position === active); });
    };
    var start = function () {
      if (hero.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(function () { show(active + 1); }, Number(hero.dataset.interval || 5000));
    };
    $('.js-hero-prev', hero) && $('.js-hero-prev', hero).addEventListener('click', function () { show(active - 1); });
    $('.js-hero-next', hero) && $('.js-hero-next', hero).addEventListener('click', function () { show(active + 1); });
    dots.forEach(function (dot) { dot.addEventListener('click', function () { show(Number(dot.dataset.slide)); }); });
    hero.addEventListener('mouseenter', function () { clearInterval(timer); });
    hero.addEventListener('mouseleave', start);
    start();
  });

  /* Product predictive search */
  var predictiveInput = $('.js-predictive-search input');
  var predictiveResults = $('.js-predictive-results');
  var searchTimer;
  predictiveInput && predictiveInput.addEventListener('input', function () {
    clearTimeout(searchTimer);
    var term = predictiveInput.value.trim();
    if (term.length < 2) { predictiveResults.innerHTML = ''; return; }
    searchTimer = setTimeout(async function () {
      try {
        var path = window.Glowrah.routes.predictive + '?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,variants.price';
        var response = await fetch(path, { headers: { Accept: 'application/json' } });
        var result = await response.json();
        var products = result.resources && result.resources.results ? result.resources.results.products : [];
        predictiveResults.innerHTML = products.length ? products.map(function (product) {
          return '<a class="predictive-result" href="' + product.url + '">' + (product.image ? '<img src="' + product.image + '" alt="">' : '<span></span>') + '<span>' + escapeHTML(product.title) + '</span><strong>' + (product.price ? money(product.price) : '') + '</strong></a>';
        }).join('') : '<p class="predictive-result">No matching lights yet.</p>';
      } catch (error) { predictiveResults.innerHTML = ''; }
    }, 220);
  });

  /* Product page: update price, availability and media when options change. */
  var productPage = $('.product-page');
  if (productPage) {
    var rawProduct = $('.js-product-json', productPage);
    var productData = rawProduct ? JSON.parse(rawProduct.textContent) : {};
    var productForm = $('.js-product-form', productPage);
    var variantSelect = $('.js-variant-select', productPage);
    var updateVariant = function () {
      var choices = $$('.product-option input:checked', productForm).map(function (input) { return input.value; });
      var variant = (productData.variants || []).find(function (item) { return item.options && item.options.every(function (option, index) { return option === choices[index]; }); });
      if (!variant) variant = (productData.variants || []).find(function (item) { return String(item.id) === variantSelect.value; });
      if (!variant) return;
      variantSelect.value = variant.id;
      var price = $('.js-product-price', productPage);
      var status = $('.js-inventory-status', productPage);
      var submit = $('.js-product-submit', productPage);
      var buy = $('.js-buy-now', productPage);
      if (price) price.innerHTML = '<div class="price ' + (variant.compare_at_price > variant.price ? 'price--sale' : '') + '"><span class="price__current">' + money(variant.price) + '</span>' + (variant.compare_at_price > variant.price ? '<s class="price__compare">' + money(variant.compare_at_price) + '</s>' : '') + '</div><span class="product-details__discount">' + (variant.compare_at_price > variant.price ? Math.round((1 - variant.price / variant.compare_at_price) * 100) + '% off' : '') + '</span>';
      if (status) { status.textContent = variant.available ? 'In stock — ready to glow' : 'Out of stock'; status.classList.toggle('is-sold-out', !variant.available); }
      [submit, buy].forEach(function (button) { if (button) { button.disabled = !variant.available; if (button === submit) $('span', button).textContent = variant.available ? 'Add to cart' : 'Sold out'; } });
      var imageId = variant.featured_media && variant.featured_media.id;
      if (imageId) { var thumb = $('.js-gallery-thumb[data-media-id="' + imageId + '"]', productPage); if (thumb) thumb.click(); }
    };
    $$('.product-option input', productForm).forEach(function (input) {
      input.addEventListener('change', function () { $('.js-option-value', input.closest('.product-option')).textContent = input.value; updateVariant(); });
    });
    $$('.js-quantity-minus', productForm).forEach(function (button) { button.addEventListener('click', function () { var input = $('input[name=quantity]', productForm); input.value = Math.max(1, Number(input.value) - 1); }); });
    $$('.js-quantity-plus', productForm).forEach(function (button) { button.addEventListener('click', function () { var input = $('input[name=quantity]', productForm); input.value = Math.min(Number(input.max || Infinity), Number(input.value) + 1); }); });
    productForm && productForm.addEventListener('submit', async function (event) {
      event.preventDefault();
      try { var formData = new FormData(productForm); await addToCart(formData.get('id'), formData.get('quantity'), true); } catch (error) { notify(error.message); }
    });
    $('.js-buy-now', productForm) && $('.js-buy-now', productForm).addEventListener('click', async function () {
      try { var formData = new FormData(productForm); await addToCart(formData.get('id'), formData.get('quantity'), false); location.assign('/checkout'); } catch (error) { notify(error.message); }
    });
    $$('.js-gallery-thumb', productPage).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mediaId = thumb.dataset.mediaId;
        $$('.product-gallery__slide', productPage).forEach(function (slide) { slide.classList.toggle('is-active', slide.dataset.mediaId === mediaId); });
        $$('.js-gallery-thumb', productPage).forEach(function (item) { item.classList.toggle('is-active', item === thumb); });
      });
    });
    $$('.js-product-tabs button', productPage).forEach(function (button) {
      button.addEventListener('click', function () {
        var tab = button.dataset.tab;
        $$('.js-product-tabs button', productPage).forEach(function (item) { item.classList.toggle('is-active', item === button); item.setAttribute('aria-selected', String(item === button)); });
        $$('.product-tabs__panel', productPage).forEach(function (panel) { panel.classList.toggle('is-active', panel.dataset.panel === tab); });
      });
    });
    $$('.js-image-zoom', productPage).forEach(function (button) {
      button.addEventListener('click', function () {
        var lightbox = d.createElement('div');
        lightbox.className = 'modal is-open';
        lightbox.innerHTML = '<div class="modal__backdrop"></div><section class="modal__content" role="dialog" aria-modal="true" aria-label="Expanded product image"><button class="modal__close" type="button" aria-label="Close">×</button><img src="' + button.dataset.imageUrl + '" alt="' + escapeHTML((button.querySelector('img') || {}).alt || productData.title) + '"></section>';
        d.body.append(lightbox);
        lock(true);
        $$('.modal__backdrop,.modal__close', lightbox).forEach(function (closeButton) { closeButton.addEventListener('click', function () { lightbox.remove(); lock(false); }); });
      });
    });
  }

  /* Collection quick-view popup */
  var quickModal = $('.js-quick-view-modal');
  $$('.js-quick-view').forEach(function (button) {
    button.addEventListener('click', async function () {
      var loading = $('.quick-view__loading', quickModal);
      var content = $('.js-quick-view-content', quickModal);
      toggleOverlay(quickModal, true);
      loading.hidden = false;
      content.innerHTML = '';
      try {
        var handle = new URL(button.dataset.productUrl, location.origin).pathname.split('/').filter(Boolean).pop();
        var response = await fetch('/products/' + handle + '.js');
        if (!response.ok) throw new Error();
        var item = await response.json();
        var variant = item.variants.find(function (value) { return value.available; }) || item.variants[0];
        content.innerHTML = '<img class="quick-view__image" src="' + (item.featured_image || '') + '" alt="' + escapeHTML(item.title) + '"><div class="quick-view__details"><p class="eyebrow">' + escapeHTML(item.type || 'LED Lighting') + '</p><h2><a href="' + item.url + '">' + escapeHTML(item.title) + '</a></h2><div class="price"><span class="price__current">' + money(variant.price) + '</span></div><p>' + escapeHTML(item.description || '').slice(0, 180) + '…</p><button class="button button--full js-quick-add" type="button" data-variant="' + variant.id + '"' + (variant.available ? '' : ' disabled') + '>' + (variant.available ? 'Add to cart' : 'Sold out') + '</button><a class="text-link" href="' + item.url + '">View full details →</a></div>';
        $('.js-quick-add', content) && $('.js-quick-add', content).addEventListener('click', async function (event) { try { await addToCart(event.currentTarget.dataset.variant, 1, true); toggleOverlay(quickModal, false); } catch (error) { notify(error.message); } });
      } catch (error) {
        content.innerHTML = '<div class="quick-view__details"><p>We could not load this preview. Please open the product page for details.</p></div>';
      } finally { loading.hidden = true; }
    });
  });
  $$('.js-quick-view-close').forEach(function (button) { button.addEventListener('click', function () { toggleOverlay(quickModal, false); }); });

  /* Local-first Wishlist, product Comparison and Recently Viewed data. */
  var productCard = function (item) {
    return '<article class="product-card"><div class="product-card__media"><a href="' + item.url + '">' + (item.featured_image ? '<img class="product-card__image" src="' + item.featured_image + '" alt="' + escapeHTML(item.title) + '">' : '') + '</a></div><div class="product-card__content"><p class="product-card__eyebrow">' + escapeHTML(item.type || 'LED Lighting') + '</p><h3><a href="' + item.url + '">' + escapeHTML(item.title) + '</a></h3><div class="price"><span class="price__current">' + money(item.price) + '</span></div></div></article>';
  };
  var getProducts = function (handles) { return Promise.all(handles.map(async function (handle) { try { var response = await fetch('/products/' + handle + '.js'); return response.ok ? response.json() : null; } catch (error) { return null; } })); };
  var updateSavedStates = function () {
    var wishlist = read(storeKeys.wish, []);
    var comparison = read(storeKeys.compare, []);
    $$('.js-wishlist-toggle').forEach(function (button) { button.classList.toggle('is-active', wishlist.includes(button.dataset.productHandle)); });
    var count = $('.js-compare-count');
    if (count) count.textContent = comparison.length;
    var bar = $('.js-compare-bar');
    if (bar) bar.hidden = !comparison.length;
  };
  d.addEventListener('click', function (event) {
    var wishButton = event.target.closest('.js-wishlist-toggle');
    if (wishButton) {
      var handle = wishButton.dataset.productHandle;
      var list = read(storeKeys.wish, []);
      list = list.includes(handle) ? list.filter(function (value) { return value !== handle; }) : list.concat([handle]);
      write(storeKeys.wish, list);
      updateSavedStates();
      notify(list.includes(handle) ? 'Saved to your wishlist' : 'Removed from your wishlist');
    }
    var compareButton = event.target.closest('.js-compare-toggle');
    if (compareButton) {
      var compareHandle = compareButton.dataset.productHandle;
      var compared = read(storeKeys.compare, []);
      if (compared.includes(compareHandle)) compared = compared.filter(function (value) { return value !== compareHandle; });
      else if (compared.length < 4) compared.push(compareHandle);
      else { notify('You can compare up to 4 products.'); return; }
      write(storeKeys.compare, compared);
      updateSavedStates();
    }
    if (event.target.closest('.js-clear-compare')) { write(storeKeys.compare, []); updateSavedStates(); location.reload(); }
    var copy = event.target.closest('.js-copy-link');
    if (copy && navigator.clipboard) navigator.clipboard.writeText(copy.dataset.url || location.href).then(function () { notify('Link copied'); });
  });
  var wishlistGrid = $('.js-wishlist-grid');
  if (wishlistGrid) getProducts(read(storeKeys.wish, [])).then(function (products) {
    var live = products.filter(Boolean);
    wishlistGrid.innerHTML = live.map(productCard).join('');
    var empty = $('.js-wishlist-empty');
    if (empty) empty.hidden = Boolean(live.length);
  });
  var recent = $('.js-recently-viewed');
  if (recent) {
    var currentHandle = recent.dataset.productHandle;
    var previous = read(storeKeys.viewed, []).filter(function (handle) { return handle !== currentHandle; });
    write(storeKeys.viewed, [currentHandle].concat(previous).slice(0, 8));
    getProducts(previous.slice(0, 4)).then(function (products) {
      var live = products.filter(Boolean);
      var grid = $('.js-recently-viewed-grid', recent);
      if (grid) grid.innerHTML = live.map(productCard).join('');
      if (!live.length) recent.hidden = true;
    });
  }
  var compareGrid = $('.js-compare-grid');
  if (compareGrid) getProducts(read(storeKeys.compare, [])).then(function (products) {
    var live = products.filter(Boolean);
    if (!live.length) return;
    var rows = [
      '<div class="compare-table__row"><span>Product</span>' + live.map(function (item) { return '<article><img src="' + (item.featured_image || '') + '" alt="' + escapeHTML(item.title) + '"><h2><a href="' + item.url + '">' + escapeHTML(item.title) + '</a></h2><strong>' + money(item.price) + '</strong></article>'; }).join('') + '</div>',
      '<div class="compare-table__row"><span>Type</span>' + live.map(function (item) { return '<p>' + escapeHTML(item.type || 'LED Lighting') + '</p>'; }).join('') + '</div>',
      '<div class="compare-table__row"><span>Options</span>' + live.map(function (item) { return '<p>' + escapeHTML(item.options.map(function (option) { return option.name; }).join(', ') || '—') + '</p>'; }).join('') + '</div>',
      '<div class="compare-table__row"><span>Availability</span>' + live.map(function (item) { return '<p>' + (item.available ? 'In stock' : 'Out of stock') + '</p>'; }).join('') + '</div>'
    ];
    compareGrid.innerHTML = '<div class="compare-table">' + rows.join('') + '</div>';
  });
  updateSavedStates();

  /* Page polish */
  $('.js-filter-open') && $('.js-filter-open').addEventListener('click', function () { $('.js-collection-filters').classList.add('is-open'); });
  $('.js-filter-close') && $('.js-filter-close').addEventListener('click', function () { $('.js-collection-filters').classList.remove('is-open'); });
  $('.js-view-list') && $('.js-view-list').addEventListener('click', function () { $('.js-collection-grid').classList.add('is-list'); $('.js-view-list').classList.add('is-active'); $('.js-view-grid').classList.remove('is-active'); });
  $('.js-view-grid') && $('.js-view-grid').addEventListener('click', function () { $('.js-collection-grid').classList.remove('is-list'); $('.js-view-grid').classList.add('is-active'); $('.js-view-list').classList.remove('is-active'); });
  var topButton = $('.js-back-to-top');
  addEventListener('scroll', function () { if (topButton) topButton.classList.toggle('is-visible', scrollY > innerHeight); }, { passive: true });
  topButton && topButton.addEventListener('click', function () { scrollTo({ top: 0, behavior: 'smooth' }); });

  /* Exit-intent offer: suppression is stored for the configured number of days. */
  var popup = $('.js-newsletter-popup');
  if (popup && !sessionStorage.getItem('glowrah-popup-seen')) {
    var popupDays = Number(popup.dataset.popupDays || 7);
    var eligible = Date.now() - Number(localStorage.getItem(storeKeys.popup) || 0) > popupDays * 86400000;
    var showPopup = function () { if (eligible && !popup.classList.contains('is-open')) { sessionStorage.setItem('glowrah-popup-seen', '1'); toggleOverlay(popup, true); } };
    if (eligible) {
      d.addEventListener('mouseout', function (event) { if (!event.relatedTarget && event.clientY < 8) showPopup(); }, { once: true });
      setTimeout(function () { if (innerWidth < 700) showPopup(); }, 18000);
    }
    $$('.js-popup-close').forEach(function (button) { button.addEventListener('click', function () { localStorage.setItem(storeKeys.popup, String(Date.now())); toggleOverlay(popup, false); }); });
  }
}());
